module.exports = __webpack_public_path__ + "assets/images/no-dataefb90c04.png";